module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.availableLanguages), function(language) {
    return _c('li', {
      staticClass: "item",
      class: {
        'item--current': _vm.$store.state.currentFormLanguage === language.code
      },
      on: {
        "click": function($event) {
          return _vm.changeLanguage(language.code)
        }
      }
    }, [_c('img', {
      staticClass: "item__flag",
      attrs: {
        "src": language.flag,
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(language.label) + "\n\t")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e12e277"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormLanguageSwitcher.vue
// module id = 722
// module chunks = 0